import { Component, EventEmitter, Input, Output, ElementRef, ViewChild } from '@angular/core';
import { NgxPopupComponent } from '../../ngx-popups/ngx-popups/components/popup.component';

@Component({
    selector: 'app-file-import-modal',
    templateUrl: './file-import-modal.component.html',
    styleUrls: ['./file-import-modal.component.scss'],
    standalone: false
})
export class FileImportModalComponent {
  @Input() popup: NgxPopupComponent;
  @Input() title: string = 'UPLOAD FILE';
  @Input() description: string = 'Import a file. Please select a valid file to upload.';
  @Input() warningText?: string; // Displayed in red with warning icon
  @Input() noteText?: string; // Displayed as regular text (not red)
  @Input() acceptedFileTypes: string = '*'; // e.g., '.json', '.csv', '.xlsx', etc.
  @Input() fileTypeDescription: string = 'file'; // e.g., 'JSON file', 'CSV file', etc.
  @Output() fileSelected = new EventEmitter<File>();
  @Output() cancelled = new EventEmitter<void>();

  @ViewChild('fileInput', { static: true }) fileInput: ElementRef<HTMLInputElement>;

  selectedFile: File | null = null;
  fileName: string = '';

  onFileSelected(event: any): void {
    const file = event.target.files[0];
    if (file) {
      this.selectedFile = file;
      this.fileName = file.name;
    }
  }

  clearFile(): void {
    this.selectedFile = null;
    this.fileName = '';
    if (this.fileInput.nativeElement) {
      this.fileInput.nativeElement.value = '';
    }
  }

  openFilePicker(): void {
    this.fileInput.nativeElement.click();
  }

  onUpload(): void {
    if (this.selectedFile) {
      this.fileSelected.emit(this.selectedFile);
    }
  }

  onCancel(): void {
    this.cancelled.emit();
    if (this.popup) {
      this.popup.close();
    }
  }
}
